import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';

/**
 * This component is responsible for the display of standardized footer actions
 *
 * @export
 */
@Component({
    selector: 'hypecast-admin-dialog-footer',
    templateUrl: './dialog-footer.component.html',
    styleUrl: './dialog-footer.component.scss',
    standalone: true,
    imports: [MatDividerModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogFooterComponent {}
